import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { ListRetentionPoliciesResponse } from '@xver/apis/v1/sammeln/retention/model';

export const RETENTION_POLICIES_QUERY_KEY = 'apis.v1.sammeln.retention.list';

export function useRetentionPoliciesQuery(projectIdOrName: string) {
    return useQuery<ListRetentionPoliciesResponse>({
        queryKey: [RETENTION_POLICIES_QUERY_KEY, projectIdOrName],
        queryFn: () => Endpoints.v1.Sammeln.Retention.listRetentionPolicies(projectIdOrName),
        enabled: !!projectIdOrName,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
    });
}
